export default "__VITE_ASSET__AQWcgR2a__"